import stickybits from 'stickybits'
import onResize from '../utils/onResize'

import withResponsive from '../hoc/withResponsive'

export default withResponsive({
  name: 'sticky-el',

  componentDidMount () {
    this.off = onResize(this.onResize.bind(this))

    this.onResize()

    setTimeout(() => {
      this.initSidebar()
    }, 500)

    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        if (this.props.screens.min === 'lg' && window.innerWidth < 1024) {
          this.sidebar.cleanup()
        }
      }, 750)
    })

    const imgs = document.querySelectorAll('img')

    Array.from(imgs).forEach(img => {
      img.addEventListener('load', () => {
        this.sidebar.update()
      })
    })
  },

  componentWillUnmount () {
    this.off()
  },

  onResize () {
    if (this.sidebar !== undefined) {
      this.sidebar.update()
    }
  },

  initSidebar () {
    this.sidebar = stickybits('[js-sticky-el-el', {
      useFixed: true,
      stickyBitStickyOffset: 120,
    })
  },
})
